import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import ButtonContainer from './button-container';
import styles from './button.module.scss';

const cx = classnames.bind(styles);

function Button({ children, size, type, variant, ...rest }) {
  const css = cx({
    button: true,
    [`button-${variant}`]: variant,
    [`button-${size}`]: size,
  });

  return (
    <button type={type} className={css} {...rest}>
      {children}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['submit', 'button']),
  size: PropTypes.oneOf(['small', 'large']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'text', 'outline', 'white']),
};

Button.defaultProps = {
  size: null,
  type: 'button',
  variant: 'primary',
};

Button.Container = ButtonContainer;

export default Button;
